<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span>Dashboard List</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="roles"
                      outlined
                      item-text="name"
                      @change="selectRole($event)"
                      label="Dashboard"
                      return-object
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingBtn" @click="closeDialog()">
                Close
              </v-btn>
              <v-btn
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onSubmit()"
                class="px-10"
              >
                Proceed
              </v-btn>
            </v-card-actions>
          </v-form>
          <!-- <Snackbar></Snackbar> -->
        </v-card>
      </v-dialog>
      <!-- <Snackbars :isShow="isShow" :testDisplay="textDisplay"></Snackbars> -->
    </v-col>
  </v-row>
</template>

<script>
// import moment from "moment";
// import ChangePasswordForm from "../../components/ChangePasswordForm.vue";
export default {
  name: "DashboardListDialog",
  components: {
    // ChangePasswordForm,
  },
  data() {
    return {
      selectedRole: {},
      loadingBtn: false,
      items: ["Foo", "Bar", "Fizz", "Buzz"],
    };
  },

  props: ["dialog"],

  methods: {
    closeDialog() {
      // this.$refs.form.reset();
      this.$emit("close", true);
    },

    selectRole(e) {
      this.selectedRole = e;
      // this.$store.dispatch("addDashboardRole", e).then(() => {
      //   this.$router.push(`${e.link}`);
      // });
    },

    onSubmit() {
      this.loadingBtn = true;
      this.$store.dispatch("addDashboardRole", this.selectedRole).then(() => {
        this.loadingBtn = false;
        this.$emit("close", true);
        this.$store.dispatch("add_role", this.selectedRole.link);
        this.$router.push(`/${this.selectedRole.link}`);
      });
    },
  },
  computed: {
    userData() {
      return this.$store.getters.userData;
    },

    roles() {
      const current = this.$store.getters.userData;

      if (Object.keys(current).length === 0) {
        return [];
      }

      const roles = current.adminLogin.roles.filter((role) => {
        return role.code != "api";
      });
      return roles;
    },
  },

  watch: {},
};
</script>
